<template>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M6.6665 6.66699L13.3332 13.3337" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M13.3332 6.66699L6.6665 13.3337" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>
</template>
<script setup lang="ts" />